const controller = { public: {} };

let receivers = [];

function removeReceiver(cb) {
  receivers = receivers.filter((receiver) => receiver !== cb);
}

function registerReceiver(cb) {
  if (typeof cb !== 'function') {
    console.log('Notification receiver should be a function');
    return () => {};
  }

  receivers.push(cb);
  return () => removeReceiver(cb);
}

controller.add = function addNotification(notificationData = {}) {
  receivers.forEach((receiver) => {
    receiver(notificationData);
  });
};

controller.registerReceiver = registerReceiver;
controller.removeReceiver = removeReceiver;

controller.public.addNotification = controller.add;
controller.public.registerReceiver = registerReceiver;
controller.public.removeReceiver = removeReceiver;
// Keep the historical misspelling for existing callers.
controller.public.registerReciever = registerReceiver;

controller.reset = () => {
  // Notifications are UI subscriptions, not scene data. Keep receivers attached so
  // the app-level notification container survives Inventum scene setup/cleanup.
};

if (typeof window !== 'undefined') {
  window.Inventum = window.Inventum || {};
  window.Inventum.notifications = controller.public;
}

export { controller as notifications };
